import React from "react";
import { Modal, Select, DatePicker, InputNumber } from "antd";
import moment from "moment";
const { Option } = Select;

export const UserDefinedModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
  fields,
}) => {
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        style={{width:"40%"}}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "1rem",
          }}
        >
          {fields &&
            fields.map((data, index) => (
              <div key={index} style={{ marginBottom: "8px" }}>
                {Object.keys(data).map((key, index1) => {
                  const { value, Component, title, onChange, name, style } =
                    data[key];
                  return (
                    <div key={index1} style={style || {}}>
                     <h3 className="inputTitle">{title || value.title}</h3>
                      {Component ? (
                        <Component
                          name={name}
                          value={value}
                          onChange={(e) => {
                            e.preventDefault();
                            onChange(index, e.target.value);
                          }}
                        />
                      ) : (
                        <input
                          className="roleInput"
                          placeholder={title || value.title}
                          name={name}
                          value={value}
                          onChange={(e) => {
                            e.preventDefault();
                            onChange(index, e.target.value);
                          }}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Date Purchase</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Date"
              name="purchaseDate"
              value={data && data.purchaseDate && moment.utc(data.purchaseDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("purchaseDate", date);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Purchase Price</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Purchase Price"
                name="purchasePrice"
                value={data && data.purchasePrice}
                id="purchasePrice"
                onChange={(value) => {
                  handleChange("purchasePrice", value);
                }}
              />
            </div>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Date Sold</h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Date Sold"
              name="saleDate"
              value={data && data.saleDate && moment.utc(data.saleDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("saleDate", date);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Sale Price</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Sale Price"
                name="salePrice"
                value={data && data.salePrice}
                id="salePrice"
                onChange={(value) => {
                  handleChange("salePrice", value);
                }}
              />
            </div>
          </div>

          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Short Term/Long Term</h3>
            <Select
              showSearch
              placeholder="-Select-"
              value={data && data.term}
              onChange={(value, id) => {
                console.log("value", value);
                handleChange("term", value);
              }}
            >
              {["Short Term", "Long Term"].map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Capital Gain</h3>
            <div className="inputWrapper" style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: "15px",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(0, 0, 0, 0.65)",
                  background: "#fafafa",
                  borderRadius: "4px",
                  border: "1px solid #d1d5db",
                }}
              >
                $
              </span>
              <InputNumber
                step={1}
                formatter={(value) =>
                  value
                    ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : ""
                }
                parser={(value) => value.replace(/,/g, "")}
                // formatter={(value) =>
                //   ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                className="Input"
                placeholder="Capital Gain"
                name="capitalGain"
                value={data && data.capitalGain}
                id="capitalGain"
                onChange={(value) => {
                  handleChange("capitalGain", value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.asset}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
